// 用户登录.
export const USER_LOGIN = 'USER_LOGIN'

// 退出登录.

export const USER_LOGOUT = 'USER_LOGOUT'

// 公司信息
export const COMPANY_INFO = 'COMPANY_INFO'

// 全局提示
export const SHOW_GUIDANCE = 'SHOW_GUIDANCE'

/*
 * action 创建函数
 * 用户登录.
 * @param users.
 */
export function userLogin(users) {
  return {
    type: USER_LOGIN,
    users
  }
}

/*
 * action 创建函数
 * 退出登录.
 * @param users.
 */
export function userLogout() {
  return {
    type: USER_LOGOUT
  }
}

/*
 * action 创建函数
 * 公司信息.
 * @param companyInfo.
 */
export function setCompanyInfo(companyInfo) {
  return {
    type: COMPANY_INFO,
    companyInfo
  }
}

/*
 * action 创建函数
 * 全局提示.
 * @param visible.
 */
export function setShowGanderce(visible) {
  return {
    type: SHOW_GUIDANCE,
    visible
  }
}
